import { Empty, Table, TableProps } from 'antd';
import React from 'react';
import { getShareColumns } from './shareColumns';
import { useTranslation } from 'react-i18next';
import { IColumn } from 'interfaces';
import classes from './ShareTable.module.scss'
import { useAppSelector } from 'store/hook';
import { ITempLinksItem } from 'interfaces/AnalyticTypes';
import analytics from 'api/analytics';

type ShareTableProps = {
  period: [string, string, string];
  choosenRoom?: string;
}

const ShareTable = ({choosenRoom, period }: ShareTableProps) => {
  const [modifiedColumns, setModifiedColumns] = React.useState<IColumn[]>([]);
  const [isLoadingTempLinks, setIsLoadingTempLinks] = React.useState(false);
  const [tempLinksData, setTempLinksData] = React.useState<ITempLinksItem[]>([]);

  const { messageApi } = useAppSelector((state) => state.windowState);

  const { t, i18n } = useTranslation();

  const getTempLinks = async (period: [string, string, string], room?: string) => {
    setIsLoadingTempLinks(true);
    try {
      const tempLinks = await analytics.getAnalyticsTempsLinks({room, from: period[0], to: period[1]});  
      setTempLinksData(tempLinks.data.map((el: ITempLinksItem, i: number) => ({ ...el, key: i })));
    } catch (e) {
      messageApi?.error(t('Analytics.errors.temp_links_data'), 6)
    } finally {
      setIsLoadingTempLinks(false);
    };
  };

  React.useEffect(() => {
    getTempLinks(period, choosenRoom);
  }, [choosenRoom, period[2]]);
  
  React.useEffect(() => {
    setModifiedColumns(getActualFilters(tempLinksData));
  }, [tempLinksData, i18n.language]);

  const getActualFilters = (dataSource: any) => {
    const logsColumns = getShareColumns(t);
    const columnsWithFilters = ['entityname', 'sender', 'recipient'];

    return logsColumns.map((col: IColumn) => {
      const needFilter = columnsWithFilters.includes(col.dataIndex)
      const unicValues = needFilter ? Array.from(new Set(dataSource.map((log: any) => log[col.dataIndex]))) : [];
      const currentFilters = needFilter ? unicValues.map((value: any) => ({ value: value, text: value })) : [];     
      return {
        ...col,
        render: (value: any, info: any) => renderCell({value, info, col}),
        filters: needFilter && currentFilters,
        onFilter: (value: boolean, record: any) => record[col.dataIndex] === value,
      }
    })
  };

  const renderCell = (props: any) => {
    const { value, info, col } = props;
    return value;
  };

  const onChange: TableProps<ITempLinksItem>['onChange'] = (pagination, filters, sorter, extra) => {    
    if (extra.action === 'filter') {
      setModifiedColumns(getActualFilters(extra.currentDataSource));
    };
  };
  
  return (
    <Table
      className={classes.shareTable}
      dataSource={tempLinksData}
      columns={modifiedColumns}
      locale={{emptyText: 
        <Empty
          description={ isLoadingTempLinks
            ? t('Analytics.share.loading')
            : t('Analytics.share.empty')
          }
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      }}
      onChange={onChange}
      loading={isLoadingTempLinks}
      pagination={false}
      size='small'
      scroll={{
        y: `411px`,
        // x: 'max-content'
      }}
    />
  );
}

export default ShareTable;
